'use client';
import { useMediaQuery } from '@react-hookz/web';

import { type BotGridItem } from '~entities/grid';
import { GridGenerateItem, GridItem } from '~entities/grid';
import { GridWrapper } from '~entities/grid/ui/GridWrapper';
import { useIsAnimatedGrid } from '~features/tags';
import { MqTablet } from '~shared/ui/theme/media';

import { useGridCardClick } from '../../hooks/useGridCardClick';

type Props = {
	bots: BotGridItem[];
	showSpecial?: boolean;
};

export const ExposedGridInner = ({ bots, showSpecial }: Props) => {
	const { userLevel, handleClick } = useGridCardClick();

	const isAnimatedGrid = useIsAnimatedGrid();
	const isTablet = useMediaQuery(MqTablet.replace('@media ', ''));

	return (
		<GridWrapper>
			{showSpecial && (
				<GridGenerateItem
					key={`generate-item${isAnimatedGrid ? '-animated' : ''}`}
					imageUrl="/img/generator/grid-generated-bot-image.webp"
					videoUrl="/assets/video/grid-generated-bot-video.mp4"
					index={0}
					animated={isAnimatedGrid}
					mobileRow={isTablet ? NaN : 2}
				/>
			)}
			{bots.map((bot, index) => (
				<GridItem
					key={bot.clientId}
					index={showSpecial ? index + 1 : index}
					item={bot}
					userLevel={userLevel}
					animated={isAnimatedGrid}
					mobileRow={isTablet ? NaN : 2}
					onClick={handleClick}
				/>
			))}
		</GridWrapper>
	);
};
